export const autoCompleteEmpty = {
  PRISTINE: 'Type to Search',
  LOADING: 'Loading...',
  NO_OPTIONS: 'No options',
  TOUCHED: undefined,
};
